import type * as Types from '../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateChatAsyncMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  message: Types.Scalars['String']['input'];
}>;


export type CreateChatAsyncMutationPage = { readonly __typename?: 'RootMutationType', readonly createChatAsync: { readonly __typename?: 'AiAgentChat', readonly id: string, readonly title?: string | null, readonly uuid: string, readonly insertedAt: string, readonly updatedAt: string, readonly messages: ReadonlyArray<{ readonly __typename?: 'AiAgentChatMessage', readonly id: string, readonly uuid: string, readonly role: Types.AiAgentChatMessageRole, readonly content: string, readonly status: Types.AiAgentChatMessageStatus, readonly inputTokens?: number | null, readonly outputTokens?: number | null, readonly insertedAt: string }>, readonly tokenUsage: { readonly __typename?: 'AiAgentTokenUsage', readonly inputTokens: number, readonly outputTokens: number } } };

export type SendChatMessageAsyncMutationVariables = Types.Exact<{
  chatId: Types.Scalars['ID']['input'];
  message: Types.Scalars['String']['input'];
}>;


export type SendChatMessageAsyncMutationPage = { readonly __typename?: 'RootMutationType', readonly sendChatMessageAsync: { readonly __typename?: 'AiAgentSendMessageResult', readonly chat: { readonly __typename?: 'AiAgentChat', readonly id: string, readonly title?: string | null }, readonly message: { readonly __typename?: 'AiAgentChatMessage', readonly id: string, readonly uuid: string, readonly role: Types.AiAgentChatMessageRole, readonly content: string, readonly status: Types.AiAgentChatMessageStatus, readonly inputTokens?: number | null, readonly outputTokens?: number | null, readonly insertedAt: string } } };

export type RenameChatMutationVariables = Types.Exact<{
  chatId: Types.Scalars['ID']['input'];
  title: Types.Scalars['String']['input'];
}>;


export type RenameChatMutationPage = { readonly __typename?: 'RootMutationType', readonly renameChat: { readonly __typename?: 'AiAgentChat', readonly id: string, readonly title?: string | null } };

export type DeleteChatMutationVariables = Types.Exact<{
  chatId: Types.Scalars['ID']['input'];
}>;


export type DeleteChatMutationPage = { readonly __typename?: 'RootMutationType', readonly deleteChat: boolean };


export const CreateChatAsyncDocument = gql`
    mutation CreateChatAsync($companyId: ID!, $message: String!) {
  createChatAsync(companyId: $companyId, message: $message) {
    id
    title
    uuid
    messages {
      id
      uuid
      role
      content
      status
      inputTokens
      outputTokens
      insertedAt
    }
    tokenUsage {
      inputTokens
      outputTokens
    }
    insertedAt
    updatedAt
  }
}
    `;
export type CreateChatAsyncMutationFn = Apollo.MutationFunction<CreateChatAsyncMutationPage, CreateChatAsyncMutationVariables>;

/**
 * __useCreateChatAsyncMutation__
 *
 * To run a mutation, you first call `useCreateChatAsyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatAsyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatAsyncMutation, { data, loading, error }] = useCreateChatAsyncMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useCreateChatAsyncMutation(baseOptions?: Apollo.MutationHookOptions<CreateChatAsyncMutationPage, CreateChatAsyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChatAsyncMutationPage, CreateChatAsyncMutationVariables>(CreateChatAsyncDocument, options);
      }
export type CreateChatAsyncMutationHookResult = ReturnType<typeof useCreateChatAsyncMutation>;
export type CreateChatAsyncMutationResult = Apollo.MutationResult<CreateChatAsyncMutationPage>;
export type CreateChatAsyncMutationOptions = Apollo.BaseMutationOptions<CreateChatAsyncMutationPage, CreateChatAsyncMutationVariables>;
export const SendChatMessageAsyncDocument = gql`
    mutation SendChatMessageAsync($chatId: ID!, $message: String!) {
  sendChatMessageAsync(chatId: $chatId, message: $message) {
    chat {
      id
      title
    }
    message {
      id
      uuid
      role
      content
      status
      inputTokens
      outputTokens
      insertedAt
    }
  }
}
    `;
export type SendChatMessageAsyncMutationFn = Apollo.MutationFunction<SendChatMessageAsyncMutationPage, SendChatMessageAsyncMutationVariables>;

/**
 * __useSendChatMessageAsyncMutation__
 *
 * To run a mutation, you first call `useSendChatMessageAsyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendChatMessageAsyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendChatMessageAsyncMutation, { data, loading, error }] = useSendChatMessageAsyncMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSendChatMessageAsyncMutation(baseOptions?: Apollo.MutationHookOptions<SendChatMessageAsyncMutationPage, SendChatMessageAsyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendChatMessageAsyncMutationPage, SendChatMessageAsyncMutationVariables>(SendChatMessageAsyncDocument, options);
      }
export type SendChatMessageAsyncMutationHookResult = ReturnType<typeof useSendChatMessageAsyncMutation>;
export type SendChatMessageAsyncMutationResult = Apollo.MutationResult<SendChatMessageAsyncMutationPage>;
export type SendChatMessageAsyncMutationOptions = Apollo.BaseMutationOptions<SendChatMessageAsyncMutationPage, SendChatMessageAsyncMutationVariables>;
export const RenameChatDocument = gql`
    mutation RenameChat($chatId: ID!, $title: String!) {
  renameChat(chatId: $chatId, title: $title) {
    id
    title
  }
}
    `;
export type RenameChatMutationFn = Apollo.MutationFunction<RenameChatMutationPage, RenameChatMutationVariables>;

/**
 * __useRenameChatMutation__
 *
 * To run a mutation, you first call `useRenameChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameChatMutation, { data, loading, error }] = useRenameChatMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useRenameChatMutation(baseOptions?: Apollo.MutationHookOptions<RenameChatMutationPage, RenameChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameChatMutationPage, RenameChatMutationVariables>(RenameChatDocument, options);
      }
export type RenameChatMutationHookResult = ReturnType<typeof useRenameChatMutation>;
export type RenameChatMutationResult = Apollo.MutationResult<RenameChatMutationPage>;
export type RenameChatMutationOptions = Apollo.BaseMutationOptions<RenameChatMutationPage, RenameChatMutationVariables>;
export const DeleteChatDocument = gql`
    mutation DeleteChat($chatId: ID!) {
  deleteChat(chatId: $chatId)
}
    `;
export type DeleteChatMutationFn = Apollo.MutationFunction<DeleteChatMutationPage, DeleteChatMutationVariables>;

/**
 * __useDeleteChatMutation__
 *
 * To run a mutation, you first call `useDeleteChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChatMutation, { data, loading, error }] = useDeleteChatMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useDeleteChatMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChatMutationPage, DeleteChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChatMutationPage, DeleteChatMutationVariables>(DeleteChatDocument, options);
      }
export type DeleteChatMutationHookResult = ReturnType<typeof useDeleteChatMutation>;
export type DeleteChatMutationResult = Apollo.MutationResult<DeleteChatMutationPage>;
export type DeleteChatMutationOptions = Apollo.BaseMutationOptions<DeleteChatMutationPage, DeleteChatMutationVariables>;